import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import dmax from "../../../../assets/info/d-max-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const IsuzuDMax = () => {
  useSmallNav("Isuzu D-Max");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Isuzu D-Max"} bolder />
        <InfoHero image={dmax} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Czy jesteś posiadaczem Isuzu D-Max? Szukasz części zawieszenia lub ulepszeń zawieszenia?"
              }
            />
            <InfoHeader
              size="smaller"
              text={"Jeśli tak, to trafiłeś we właściwe miejsce."}
            />
            <p>
              W firmie Pedders Suspension oferujemy szeroką gamę części
              zawieszenia, w tym liczne części wzmocnione, odpowiednie do
              wszelkich zastosowań.
            </p>
            <p>
              Dla osób przewożących ciężkie ładunki lub regularnie holujących
              jesteśmy w stanie zaoferować ulepszone tylne sprężyny i
              amortyzatory, aby lepiej sprostać wymaganiom takiego użytkowania.
              Dzięki 3 różnym kombinacjom resorów tylnych (w zależności od
              modelu) znajdziesz coś dla siebie. Dla osób poruszających się na
              granicy możliwości pojazdu, można je uzupełnić o system poduszek
              powietrznych. Niezależnie od zastosowania, będziemy mieli
              kombinację części do sprostania tym oczekiwaniom!
            </p>
            <p>
              Popularne wśród naszych ulepszeń są zestawy do podnoszenia: czy to
              do poważnej jazdy w terenie, czy po prostu do bardziej agresywnego
              wyglądu. Ponownie mamy części, których potrzebujesz. Wiele opcji
              sprężyn oraz amortyzatorów pozwala dostosować pojazd do Twoich
              potrzeb.
            </p>
            <p>
              Przejrzałeś naszą listę zestawów i części, ale nadal nie jesteś
              pewien, czego potrzebujesz? W takim razie skontaktuj się z nami, a
              nasz zespół będzie mógł Ci pomóc.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/V9VVX_krAbw"
              title={"Isuzu D-Max Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/5olMu1M-eJ8"
              title={"Isuzu D-Max Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              title={"Isuzu D-Max Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/1VOpGb50izY"
              title={"Isuzu D-Max Video 4"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Isuzu D-Max Video 5"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Isuzu")
              .models.find((e) => e.display === "D-Max")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Isuzu" model="D-Max" /> */}
      </Container>
    </section>
  );
};

export default IsuzuDMax;
